import { useMutation } from "react-query";
import { useDispatch } from "react-redux";

import { getErrorMessage } from "helpers";
import { chargebacksDetailsService } from "services";
import { uiActions } from "store";
import { ErrorResponse } from "types";

const useDownloadChargebackReportMutation = (
	chargebackId: string,
	token: string,
) => {
	const dispatch = useDispatch();

	return useMutation(
		async () => {
			if (!token) return Promise.reject("Token is missing");
			return chargebacksDetailsService.downloadChargebackReport(
				chargebackId,
				token,
			);
		},
		{
			onError(error: ErrorResponse) {
				dispatch(
					uiActions.showErrorNotification({
						title: getErrorMessage(error),
					}),
				);
			},
		},
	);
};

export default useDownloadChargebackReportMutation;
